import { LazyRouterProvider } from './providers/lazy-router-provider';

export const App = () => {
  return <LazyRouterProvider />;
};
